<template>
  <div class="home-page">
    <div class="header">
      <div class="cover-img">
        <div class="content">
          <CustomHeader></CustomHeader>
          <div class="wrapper">
            <div class="header">

              <div class="header__section pt-lg-5 pt-md-3 pt-sm-2 mt-lg-4">
                <div :class="{ 'show': showContent }" class="header__section-info">
                  <div class="title">{{ $t('diesel.title') }}</div>
                </div>
                <transition name="fade">
                  <div v-if="showImage" class="header__section-img"></div>
                </transition>
              </div>
            </div>
            <div class="description" ref="description">
              {{ $t('diesel.desc') }}
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="body-section">
      <div class="content">
        <BoxSection
            position="left"
            title="KOHLER"
            :description="$t('diesel.kohler')"
            pdfLink="/pdfs/elektroagregati/kohler.pdf"
            pdfLink2="/pdfs/elektroagregati/kohler2.pdf"
            :pdfLabel="$t('pdf')"
            imageSrc="/img/kohler.png"
        />
        <BoxSection
            position="right"
            title="TEKSAN"
            :description="$t('diesel.teksan')"
            pdfLink="/pdfs/elektroagregati/teksan.pdf"
            :pdfLabel="$t('pdf')"
            imageSrc="/img/teksan.png"
        />
        <BoxSection
            position="left"
            title="AKSA"
            :description="$t('diesel.aksa1') + $t('diesel.aksa2')"
            pdfLink="/pdfs/elektroagregati/aksa.pdf"
            :pdfLabel="$t('pdf')"
            imageSrc="/img/aksa.png"
        />

        <MarqueeLogos/>
      </div>

    </div>
    <div class="footer">
      <div class="cover-img">
        <div class="img">
          <div class="img3"></div>
        </div>
        <div class="content">
          <FooterSection></FooterSection>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import FooterSection from "@/components/Footer.vue";
import CustomHeader from "@/components/CustomHeader.vue";
import BoxSection from '@/components/BoxSection.vue'
import MarqueeLogos from '@/components/MarqueeLogos.vue';

export default {
  name: 'ElektroAgregati',
  components: {
    FooterSection,
    CustomHeader,
    BoxSection,
    MarqueeLogos
  },
  data() {
    return {
      showImage: false,
      showContent: false,
    };
  },
  mounted() {
    this.showImage = true;
    setTimeout(() => {
      this.$nextTick(() => {
        this.$refs.description.classList.add('fade-in');
      });
    }, 500);
    setTimeout(() => {
      this.showContent = true;
    }, 500);

  },

}
</script>

<style lang="scss" scoped>
@import "~@/assets/main.scss";

.home-page {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin: 0;
  padding: 0;
  overflow-y: auto;
}

.wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .header {
    width: 70vw;
    display: flex;

    @include respond(tab-land) {
      width: 95vw;
    }
    @media only screen and (min-width: 1201px) and (max-width: 1499px) {
      width: 95vw;
    }

    &__section {
      display: flex;
      width: 100%;
      justify-content: space-between;
      //   align-items: flex-start;
      align-items: center;
      margin-top: 40px;
      @include respond(phone) {
        flex-direction: column;
        margin-top: 20px;
      }

      &-info {
        display: flex;
        flex-direction: column;
        gap: 10px;
        max-width: 530px;
        width: 100%;
        text-align: left;

        transform: translateY(-100%);
        opacity: 0;
        transition: transform 1.2s ease-out, opacity 2s ease-out;
        @include respond(phone) {
          text-align: center;
        }

        &.show {
          transform: translateX(0);
          opacity: 1;
        }

        .title {
          font-size: 100px;
          font-family: "Montserrat";
          color: $primary-blue;
          font-weight: bold;
          text-transform: uppercase;
          line-height: 0.938;
          text-align: center;
          @include respond(phone) {
            font-size: 30px !important;
            width: 100%;
          }
        }

      }

      .fade-enter-active, .fade-leave-active {
        transition: opacity 1s ease-in;
      }

      .fade-enter-from, .fade-leave-to {
        opacity: 0;
      }

      .fade-enter-to, .fade-leave-from {
        opacity: 1;
      }

      &-img {
        background-image: url('~@/assets/images/naslovna-elektroagregati.png');
        border-radius: 10px;
        width: 500px;
        height: 450px;
        background-size: cover;
        @include respond(phone) {
          display: block !important;
          width: 90vw;
          height: 350px;
          border-radius: 8px;
        }
      }
    }

    .title {
      font-size: 50px;
      font-family: "Montserrat";
      color: $primary-blue;
      font-weight: bold;
      text-transform: uppercase;
      line-height: 1.3;
      @include respond(from-phone-to-tab) {
        font-size: 40px;
      }
    }
  }

  .description {
    max-width: 70vw;
    text-align: center;
    color: $primary-blue;
    font-size: 22px;
    margin-top: 80px;
    font-family: "Karla";
    opacity: 0;
    transition: opacity 3s ease-out;
    @include respond(phone) {
      text-align: justify;
      margin-top: 40px;
      font-size: 20px;
      max-width: 95vw;
    }
    @include respond(lil-phone) {
      margin-top: 20px;
    }
  }

  .description.fade-in {
    opacity: 1;
  }
}

.footer {
  position: relative;
  overflow: hidden;

  .cover-img {
    .img {
      position: relative;
    }

    .img3 {
      background-image: linear-gradient(to top, rgba(88, 135, 198, 0.74), #5887C6BD), linear-gradient(to bottom, rgb(88, 135, 198, 0.74), #5887C6BD), url('@/assets/images/bottom-bg.png');
      background-repeat: no-repeat;
      background-size: cover;
      // position: relative;
      width: 100%;
      height: 950px;
      @include respond(from-phone-to-tab) {
        height: 620px;
      }
      @include respond(phone) {
        height: 650px;
      }
    }

    img {
      position: relative;
      top: 5px;
    }

    .content {
      position: absolute;
      top: 0;
      width: 100%;
    }
  }
}

@media (max-width: 768px) {
  .background-image {
    min-height: 40vh;
  }
}
</style>
